import template from './checkin.html';

const checkinComponent = {
  restrict: 'E',
  template
};

export default checkinComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/checkin/checkin.component.js
 **/